<template>
    <div id="app">
        <v-app id="inspire">

            <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                    {{ $t('Products') }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <navi v-model="drawer"></navi>

            <v-content>
                <v-container fluid>

                    <div v-if="urunekrani">
                        <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                                <v-layout justify-start>
                                    <span class=" grey--text headline"> {{ $t('Add-Renew-New-Product') }}  </span>
                                </v-layout>
                            </v-flex>

                        </v-layout>
                        <v-divider></v-divider>
                        <v-flex xs6 sm6 md6>
                            <v-radio-group v-model="sirkettipi" row>
                                <v-radio label="Mevcut Şirket" value="0"></v-radio>
                                <v-radio :label="$t('New-Company')" value="1"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                            <v-select v-if="mevcutsirketmi" item-value="id" item-text="text"
                                :label="$t('Select-Your-Main-Company')" autofocus persistent-hint :items="AnaSirketler"
                                v-model="AnaSirket" bottom></v-select>
                        </v-flex>

                        <v-layout row wrap>
                            <v-flex xs12 sm12 md6>
                                <v-layout justify-start>
                                    <span class=" grey--text headline"> {{ $t('Your-Active-Industry') }} </span>
                                </v-layout>
                            </v-flex>

                        </v-layout>

                        <v-divider></v-divider>
                        <v-radio-group v-model="sektor" row>
                            <v-radio label="Turizm Acentası " value="0"></v-radio>
                        </v-radio-group>
                        <span class=" grey--text  headline">{{$t('Subscription-Type')}}</span>
                        <v-divider></v-divider>
                        <v-radio-group v-model="uyeliktipi" row>
                            <v-radio label="Süreli " value="0"></v-radio>
                            <v-radio label="Kontörlü" value="1"></v-radio>
                        </v-radio-group>
                        <span v-if="urunekrani" class=" grey--text  headline">{{ $t('Products') }} </span>
                        <v-divider></v-divider>
                    </div>

                    <v-layout v-if="urunekrani" row wrap>
                        <div v-for="item in productshow" v-bind:key="item.index">
                            <v-flex ma-2 xs12 sm4 md3>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                        class="mx-auto" width="300">
                                        <v-card-title>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center>
                                                        <div>
                                                            <v-layout justify-center>
                                                                <span v-if="item.UrunTip==2"
                                                                    class="display-3 font-weight-bold  grey--text">{{item.Gun}}
                                                                    {{ $t('day') }} </span>
                                                                <span v-if="item.UrunTip==3"
                                                                    class="display-3 font-weight-bold  grey--text">{{item.Kontor}}
                                                                </span>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout align-center="" justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">
                                                                    {{$t('Ticket')}} </div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">
                                                                    {{$t('Accounting')}}</div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <div class="font-weight-light grey--text title mb-2">
                                                                    {{ $t('Hotel') }}
                                                                </div>
                                                            </v-layout>
                                                            <v-layout justify-center>
                                                                <v-btn flat color="info"> {{$t('Details')}}</v-btn>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                            <v-layout justify-center>
                                                                <span class="display-1  font-weight-light red--text">{{item.Tutar
                                                                        | moneyformat}}
                                                                    ₺</span>
                                                            </v-layout>
                                                        </div>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 ma-1 md12>
                                                    <v-btn block @click="Odeme(item.UrunID,item.Tutar)"
                                                        class="white--text" color="green">
                                                        <v-icon color="white">shopping_cart</v-icon> {{$t('Buy')}}
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-title>

                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </div>

                        <v-flex ma-2 xs2 sm1 md1>
                            <v-hover>
                                <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                    class="mx-auto" width="300">
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout justify-center>
                                                    <div>
                                                        <v-layout justify-center>

                                                            <span class="display-3 font-weight-bold  grey--text">{{$t('Special')}}
                                                            </span>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                        <v-layout justify-center>
                                                            <div class="font-weight-light grey--text title mb-2">
                                                                {{$t('Ticket')}}</div>
                                                        </v-layout>
                                                        <v-layout justify-center>
                                                            <div class="font-weight-light grey--text title mb-2">
                                                                {{$t('Accounting')}}</div>
                                                        </v-layout>
                                                        <v-layout justify-center>
                                                            <div class="font-weight-light grey--text title mb-2">
                                                                {{ $t('Hotel') }}
                                                            </div>
                                                        </v-layout>
                                                        <v-layout justify-center>
                                                            <v-btn flat color="info"> {{$t('Details')}}</v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                        <v-layout justify-center>
                                                            <span
                                                                class="display-1  font-weight-light red--text">&nbsp;</span>
                                                        </v-layout>
                                                    </div>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 ma-1 md12>
                                                <v-btn block class="white--text" color="red">
                                                    <v-icon color="white">call</v-icon> {{ $t('Contact-Us') }}
                                                </v-btn>
                                            </v-flex>

                                        </v-layout>
                                    </v-card-title>

                                </v-card>
                            </v-hover>
                        </v-flex>

                    </v-layout>


                    <v-layout v-if="odemeekrani" row wrap>

                        <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                                <v-layout justify-start>
                                    <span class="headline">{{ $t('Choose-Payment-Method') }}</span>
                                </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                                <v-layout justify-end>
                                    <v-btn @click="urunleredon()" flat class="white--text" color="red">
                                        <v-icon>arrow_back_ios</v-icon> {{ $t('Return-Product-Choosing-Page') }}
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>


                        <v-flex xs12 sm12 md12>
                            <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <span class="headline"></span>
                            <v-radio-group v-model="UrunKayit.OdemeOnay" row>
                                <v-radio :label="$t('Transfer-v3')" value="false"></v-radio>
                                <v-radio :label="$t('Credit-Card')" value="true"></v-radio>
                            </v-radio-group>
                        </v-flex>


                        <v-flex ma-2 xs12 sm12 md5>
                            <v-card flat class="white--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-flex xs12 ma-2 v-if="kredikarti" sm6 md6>
                                            <v-layout justify-start>
                                                <v-icon color="pink">credit_card</v-icon> &nbsp; <span
                                                    class="title pink--text font-weight-regular">
                                                    {{ $t('Credit-Card-Details') }}
                                                </span>
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-form ref="formodeme" v-model="validOdeme" lazy-validation>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field
                                                            :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                            v-model="PaymentForm.CardNumber" :label="$t('Credit-Card-No')"
                                                          hide-details=""    mask="####-####-####-####">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>

                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field v-model="PaymentForm.CardHolder"
                                                            :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                            hide-details=""  :label="$t('Name-on-Card')">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimAy" :label="$t('Expiry-Month')"
                                                            v-model="PaymentForm.ExpirationMonth"
                                                            :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                             hide-details=""  item-text="text" item-value="id">
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimYil"
                                                            v-model="PaymentForm.ExpirationYear"
                                                            :label="$t('Expiry-Year')"
                                                            :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                              hide-details="" item-text="text" item-value="id">
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md4>
                                                        <v-text-field label="CVV" v-model="PaymentForm.Cvv"
                                                            :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                           hide-details="" mask="###">
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-form>
                                        </v-flex>

                                        <v-flex xs12 v-if="!kredikarti" sm6 md6>

                                            <v-flex xs12 pa-2 sm12 md12>
                                                <v-layout justify-center="" fill-height="" align-center="">
                                                    <span class="grey--text title"> {{$t('Transfer-Confirmation')}}</span>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 pa-2 sm12 md12>
                                                <v-layout justify-center="" fill-height="" align-center="">
                                                    <span class="red--text caption"> 
                                                        {{ $t('state-product-code-explanation-transfer-conducting') }}    
                                                    </span>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 pa-2 sm12 md12>
                                                <v-layout justify-center="" fill-height="" align-center="">
                                                    <span class="red--text caption">
                                                        {{ $t('If-completed-transfer-click-Transfer-button') }}    
                                                     </span>
                                                </v-layout>
                                            </v-flex>

                                        </v-flex>

                                        <v-flex xs12 sm6 ma-2 md6>
                                            <v-card flat class="white--text">
                                                <v-card flat="">
                                                    <v-card-actions>
                                                        <v-layout align-end="" row wrap>

                                                            <v-flex xs12 sm6 ma-2 md12>
                                                                <v-layout justify-center>
                                                                    <div>
                                                                        <v-layout justify-center>
                                                                            <div
                                                                                class="font-weight-light grey--text title mb-2">
                                                                                &nbsp;</div>
                                                                        </v-layout>
                                                                        <v-layout justify-center>
                                                                            <span
                                                                                class="display-1 font-weight-bold  grey--text">
                                                                                {{  $t('totalamount') }}
                                                                            </span>
                                                                        </v-layout>
                                                                        <v-divider></v-divider>
                                                                        <v-layout pa-2 justify-center>
                                                                            <div
                                                                                class="font-weight-regular red--text display-1 mb-2">
                                                                                {{toplamtutar | moneyformat}} ₺
                                                                            </div>
                                                                        </v-layout>
                                                                        <v-layout justify-center>
                                                                            <div
                                                                                class="font-weight-light grey--text title mb-2">
                                                                            </div>
                                                                        </v-layout>
                                                                        <v-layout justify-center>
                                                                            <v-btn v-if="!kredikarti" block
                                                                                class="white--text" @click="SatinAl()"
                                                                                color="green">
                                                                                {{ $t('Completed-my-Transfer') }}
                                                                                </v-btn>
                                                                            <v-btn v-if="kredikarti" block
                                                                                class="white--text"
                                                                                @click="KrediOdemeYap()" color="green">
                                                                                {{$t('Make-Payment')}} &nbsp;<v-icon>3d_rotation
                                                                                </v-icon>
                                                                            </v-btn>
                                                                        </v-layout>

                                                                    </div>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-card>
                                        </v-flex>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                        <v-flex ma-2 v-if="kredikarti" xs12 sm12 md6>
                            <v-card flat="">
                                <v-layout row wrap>

                                    <v-flex xs1 sm1 mt-2 md1>
                                        <v-layout justify-start="" align-center fill-height="">

                                            <img :src="cardimageLink" height="50px;" width="50px;">
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs10 mt-2 ml-2 sm10 md10>
                                        <v-layout justify-start fill-height="" align-center="">
                                            <span class=" black--text subheading"> {{binResult.KartBanka}} &nbsp;
                                                {{$t('Instalment-Rates')}}</span> &nbsp;&nbsp;
                                            <span class=" red--text caption"> *** 
                                                {{ $t('Instalment-details-will-card-details') }}
                                            </span>
                                        </v-layout>

                                    </v-flex>


                                    <v-flex xs12 sm12 md12>
                                        <v-layout justify-start>
                                            <v-divider></v-divider>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-layout row wrap>
                                            <v-flex xs12 pl-2 pt-2 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-flex xs3 sm3 md3>
                                                        <div pl-4 class="font-weight-bold grey--text subheading ">
                                                            {{ $t('Instalment-Amount-v2') }}
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs3 sm3 md3>
                                                        <div class="font-weight-bold grey--text subheading ">
                                                            {{$t('Instalment-Amount')}}
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs3 sm3 md3>
                                                        <div class="font-weight-bold grey--text subheading ">
                                                           {{$t('totalamount')}}
                                                        </div>
                                                    </v-flex>

                                                </v-layout>


                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout justify-start>
                                                    <v-divider></v-divider>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs3 sm3 md3>
                                                <v-radio-group hide-details="" v-model="secilentaksit"
                                                    :mandatory="false">
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout pl-4 row wrap="">
                                                            <v-flex v-for="item in seciliozelOran" v-bind:key="item.id"
                                                                xs12 pa-2 sm12 md12>
                                                                <v-radio :label="item.TaksitLabel" v-bind:value="item">
                                                                </v-radio>
                                                            </v-flex>

                                                        </v-layout>
                                                    </v-flex>
                                                </v-radio-group>
                                            </v-flex>


                                            <v-flex xs9 sm9 pt-4 md9>
                                                <v-flex xs12 v-for="item in seciliozelOran" v-bind:key="item.id" sm12
                                                    md12>
                                                    <v-layout row wrap="">
                                                        <v-flex xs12 pa-2 sm6 md4>
                                                            <div class="font-weight- grey--text subheading ">
                                                                {{item.TaksitTutar | moneyformat}}
                                                            </div>
                                                        </v-flex>
                                                        <v-flex xs12 pa-2 sm6 md4>
                                                            <div class="font-weight- grey--text subheading ">
                                                                {{item.ToplamTutar | moneyformat}}
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                            </v-flex>

                                        </v-layout>
                                    </v-flex>

                                    <v-divider></v-divider>

                                </v-layout>
                            </v-card>
                        </v-flex>

                    </v-layout>

                </v-container>
            </v-content>


            <v-dialog v-model="dialogyenisirket" persistent max-width="400px">
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12>
                        <v-toolbar size="120px" dark color="info">


                            <v-toolbar-title>{{ $t('New-Parent-Company') }}</v-toolbar-title>
                        </v-toolbar>
                    </v-flex>
                    <v-flex pa-1 xs12 sm12 md12>

                        <v-layout wrap>
                            <div class="flex md12">
                                <v-text-field :label="$t('Company-Title')" v-model="yenisirketunvani"></v-text-field>
                            </div>
                        </v-layout>

                    </v-flex>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" v-if="!bekle" flat @click="sirketaciptal()">{{$t('Cancel')}}</v-btn>
                        <v-btn color="info" v-if="!bekle" flat @click="yenisirketac()">{{$t("save_button")}}</v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>



                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>

        </v-app>
    </div>

</template>

<script>
    import auth from '../../../api/auth'
    import _ from 'underscore'
    import router from '../../../router'
    import helpers from "@/components/app/customcomp/helpers.js"
    import navi from "@/components/app/account/navigator.vue"
    import $ from '@/plugins/i18n.js'
    import {
        Trans
    } from '@/plugins/Translation'


    export default {
         data() {
        return {

            hataurl: 'https://nextv2.arkman.com.tr/#/odeme/hata',
            basariliurl: 'https://nextv2.arkman.com.tr/#/odeme/basarili',

            ozelOranlar: [],
            seciliozelOran: null,
            cardimageLink: 'https://param.com.tr/images/banka/diger_kredi_kart.png',

            cardimageLinkyedek: 'https://param.com.tr/images/banka/diger_kredi_kart.png',

            secilentaksit: null,
            musteriidurun: null,
            pass: null,
            yedekresponse: [],
            bekle: false,
            AnaSirketlerWiev: [],
            AnaSirketler: [],
            Sirketler: [],
            AnaSirket: {},
            Sirket: {},
            giris: true,
            Urunler: false,
            urunlerlist: [],
            active: false,
            sektor: '0',
            uyeliktipi: '0',
            productshow: [],
            odemetipi: false,
            havale: true,
            kredikarti: false,
            odemeekrani: false,
            toplamtutar: 0,
            urunekrani: true,
            musteriid: null,
            dialogyenisirket: false,
            yenisirketunvani: null,
            sirkettipi: '0',
            karttipi: [{
                    id: 'M',
                    text: 'Master Card'
                },
                {
                    id: 'VI',
                    text: 'VISA'
                },
                {
                    id: 'A',
                    text: 'American Express'
                },
            ],
            sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                '2029', '2030'
            ],
            dictionary: {
                custom: {
                    kartno: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                        min: this.$t('Card-Number-Must-16-Digits')
                    },

                    selectkarttipi: {
                        required: () => this.$t('Please-choose'),
                    },
                    kartcari: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanim: {
                        required: () => this.$t('Please-choose'),
                    },
                    selectsonkullanimyil: {
                        required: () => this.$t('Please-choose'),
                    },

                }
            },

            PaymentForm: {
                Id: null,
                CardHolder: null,
                CardNumber: null,
                Cvv: null,
                ExpirationYear: null,
                ExpirationMonth: null,
                MobilePhone: null,
                VirtualPosId: null,
                InstallmentCount: null,
                Amount: 0,
                OkUrl: 'https://nextv2.arkman.com.tr/#/odeme/basarili',
                FailUrl: 'https://nextv2.arkman.com.tr/#/odeme/hata'
            },

            itemsnavi: [{
                    icon: 'business',
                    text: this.$t('Corporate-transactions'),
                    to: 'anasirket',
                },
                {
                    icon: 'people',
                    text: this.$t('Member-Transactions'),
                    to: 'login-uye'
                },
                {
                    icon: 'people',
                    text: this.$t('Authority-Groups'),
                    to: 'login-yetkigruplist'
                }
            ],
            clipped: true,
            drawer: true,
            fixed: false,
            miniVariant: false,
            right: true,
            rightDrawer: false,
            binResult: {
                Bin: null,
                Dkk: null,
                KartBanka: null,
                KartOrg: null,
                KartTip: null,
                SanalPosId: null,
            },

            UrunKayit: {
                ID: null,
                MusteriInfo: {
                    MusteriID: null,
                    MusteriKod: null
                },
                UrunInfo: {
                    UrunID: null
                },
                UrunAdet: 1,
                BaslangicTarih: null,
                BitisTarih: null,
                Kontor: null,
                KalanKontor: null,
                SatisTarihi: null,
                SatisTutar: 0,
                Aktif: null,
                OdemeOnay: 'false'
            },

            mevcutsirketmi: true,
            yenisirket: false,
            dialog: false,
            items: [{
                    icon: 'domain',
                    text: this.$t('Corporate-transactions')
                },
                {
                    icon: 'contacts',
                    text: this.$t('Member-Transactions')
                },
            ],


            faturainfo: [],
            newuserstatus: false,
            loginstatus: true,
            e1: 0,
            e2: true,
            e3: true,
            e4: true,
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('Wrong-e-mail')
                }
            },
            Kartbilgisi: null,
            YeniKullanici: {
                UserID: null,
                MusteriID: 0,
                KullaniciAdi: null,
                Email: null,
                Sifre: null,
                Tip: 0,
                AdSoyad: null,
                Deleted: false,
                Aktif: false,
                MusteriBilgi: [],
                OdemeOnay: false,
            },
            unvan: null,
            confirm: null,
            Credential: {
                email: '',
                password: ''
            },
            valid: true,
            validOdeme: true,

            errorMsg: '',
            errorAlert: false,
        }
        },
        props: {
            source: String
        },
        methods: {

            KrediOdemeYap() {
                if (this.$refs.formodeme.validate()) {

                    this.PaymentForm.VirtualPosId = this.secilentaksit.SanalPosId
                    this.PaymentForm.InstallmentCount = this.secilentaksit.TaksitAdet
                    this.PaymentForm.Amount = this.secilentaksit.ToplamTutar
                    this.PaymentForm.MobilePhone = '553 172 10 11'

                    var params = this.PaymentForm

                    this.$http.post(auth.API_URL + 'api/ParamPos/GetPayTreeD', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        if (response.body.IsSuccessfull) {

                            var url = response.body.ContinueUrl
                            window.open(url, '_self');
                        }


                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-KartOde'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-KartOde'
                            this.snackbar = true
                        }
                    })


                }
            },
            dildegistir(a) {

                const lang = a
                const to = this.$router.resolve({
                    params: {
                        lang
                    }
                })
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location)
                    // this.locale = e
                })

            },
            logout() {
                auth.logout()
            },
            yenisirketac() {
                this.bekle = true;

                var response1 = JSON.parse(window.localStorage.getItem('response'));

                if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
                    var params = {
                        Mail: response1.Email,
                        CustomerInfo: {
                            Ad: this.yenisirketunvani
                        }
                    }

                    this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true

                        if (response.body.Status == true) {
                            this.text1 =
                                'Yeni ana şirket kayıt işleminiz tamamlandı ve şirketinize 10 günlük ücretsiz üyelik tanımlanmıştır.'
                            this.snackbar = true
                            this.dialogyenisirket = false;
                            this.sirkettipi = '0';
                            this.bekle = false;


                            var params = {
                                Email: response1.Email

                            }
                            this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {

                                this.giris = true
                                this.Urunler = false

                                this.bekle = false;
                                this.yedekresponse = response1
                                window.localStorage.removeItem('response')

                                var sirketlers = []
                                Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                                    var anasirket = {
                                        Ad: response.body[0].MusteriBilgi[key].Ad,
                                        GenelSirketler: response.body[0].MusteriBilgi[key]
                                            .Sirketler,
                                        MusteriId: response.body[0].MusteriBilgi[key]
                                            .MusteriID,
                                        MusteriKod: response.body[0].MusteriBilgi[key]
                                            .MusteriKod
                                    }
                                    sirketlers.push(anasirket)
                                });

                                var newresponse = {
                                    AdSoyad: this.yedekresponse.AdSoyad,
                                    Email: this.yedekresponse.Email,
                                    MusteriDbler: sirketlers,
                                    Token: this.yedekresponse.Token,
                                    UserId: this.yedekresponse.UserId
                                }
                                window.localStorage.setItem('response', JSON.stringify(newresponse));

                                this.guncelle();

                                //yeni response oluşturuldu burda kaldı

                            }, (response) => {
                                if (response.status === 0) {
                                    this.bekle = false;

                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                } else {
                                    this.text1 = 'Service Unavailable-WebUserList'
                                    this.snackbar = true
                                }
                            })
                        }

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-NewCustomerAdd'
                            this.bekle = false;

                            this.snackbar = true
                        }
                    })

                } else {
                    this.text1 = this.$t('Please-enter-corporate-title')
                    this.snackbar = true
                    this.bekle = false;

                }
            },
            sirketaciptal() {
                this.dialogyenisirket = false;
                this.sirkettipi = '0';
            },
            urunleredon() {
                this.urunekrani = true;
                this.odemeekrani = false;
            },

            sirketleredon() {
                this.Urunler = false;
                this.giris = true;
            },

            Odeme(urunid, fiyat) {



                if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof (this.sirkettipi) !=
                    'object') {
                    this.UrunKayit.UrunInfo.UrunID = urunid
                    this.UrunKayit.SatisTutar = fiyat
                    this.toplamtutar = fiyat;
                    this.odemeekrani = true;
                    this.urunekrani = false;


                    this.$http.post(auth.API_URL + 'api/ParamPos/GetOzelOran', null, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.ozelOranlar = response.body

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-GetOzelOran'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-GetOzelOran'
                            this.snackbar = true
                        }
                    })

                } else {
                     this.text1 = this.$t('Please-select-a-company')
                    this.snackbar = true
                }


            },
            SatinAl() {

                this.UrunKayit.SatisTarihi = getDateNow()

                this.UrunKayit.MusteriInfo.MusteriKod = this.musteriidurun

                var params = this.UrunKayit

                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerSave', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    if (response.body.Status == true) {


                        this.text1 = this.$t('Payment-successful-you-being-redirected-page')
                        this.snackbar = true

                        this.guncelle();

                        setTimeout(function () {

                            this.odemeekrani = false;
                            this.urunekrani = true;
                            this.giris = true;
                            this.Urunler = false;

                        }.bind(this), 4000)

                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })
            },
            BinKodSorgula() {
                var params = this.PaymentForm

                this.$http.post(auth.API_URL + 'api/ParamPos/GetBinCode', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.binResult = response.body

                    this.seciliozelOran = []

                    this.ozelOranlar.forEach(element => {

                        if (this.binResult.SanalPosId == element.SanalPosId) {

                            this.cardimageLink = element.KrediKartiBankaGorsel


                            element.TaksitOranlar.forEach(element1 => {


                                if (element1.Oran > -1) {

                                    var Tutar = (this.toplamtutar * element1.Oran / 100) + this
                                        .toplamtutar
                                    var taksittutar = Tutar / element1.Taksit

                                    var taksitlabel = null

                                    if (element1.Taksit == 1) {
                                        taksitlabel = this.$t('Lump-Sum')
                                    } else {
                                        taksitlabel = element1.Taksit + ' Taksit'
                                    }


                                    var taksitbilgi = {
                                        TaksitLabel: taksitlabel,
                                        TaksitAdet: element1.Taksit,
                                        SanalPosId: element.SanalPosId,
                                        TaksitTutar: taksittutar,
                                        ToplamTutar: Tutar
                                    }


                                    this.seciliozelOran.push(taksitbilgi)

                                }

                            });
                            this.secilentaksit = this.seciliozelOran[0]

                        }

                    });




                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductCustomerSave'
                        this.snackbar = true
                    }
                })


            },
            KartOdemesiYap() {},
            urunleregit() {
                this.AnaSirket = null
                this.giris = false
                this.Urunler = true
                var params = {
                    ProductID: 0,
                    ProductType: 0
                }

                this.$http.post(auth.API_URL + 'api/Register/ProductList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.urunlerlist = response.body
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 2)
                            this.productshow.push(element)
                    });
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductList'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-ProductList'
                        this.snackbar = true
                    }
                })
            },
            getDateNow,
            guncelle
        },
        filters: {

            dateformat: function (t) {
                return helpers.dateformat(t);
            },
            moneyformat: function (m) {
                return helpers.moneyformat(m);
            },

            bakiyekontrol: function (m) {
                return helpers.bakiyekontrol(m);
            }

        },
        beforeMount: beforeMount,

        components: {
            'navi': navi
        },
        watch: {

            'secilentaksit': function (value) {
                this.toplamtutar = value.ToplamTutar
            },
            'PaymentForm.CardNumber': function (value) {
                if (value.length == 6) {
                    this.BinKodSorgula();
                }

                if (value.length < 6) {
                    this.binResult.KartBanka = null
                    this.seciliozelOran = []
                    this.cardimageLink = this.cardimageLinkyedek
                    this.toplamtutar = this.UrunKayit.SatisTutar
                }
            },


            'uyeliktipi': function (value) {
                if (value == 0) {
                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 2)
                            this.productshow.push(element)
                    });
                } else {

                    this.productshow = [];
                    this.urunlerlist.forEach(element => {
                        if (element.UrunTip == 3)
                            this.productshow.push(element)
                    });

                }
            },
            'UrunKayit.OdemeOnay': function (value) {
                if (value == 'false') {
                    this.havale = true;
                    this.kredikarti = false;
                } else {

                    this.havale = false;
                    this.kredikarti = true;

                }
            },
            'AnaSirket': function (value) {

                if (value != null) {
                    this.musteriidurun = value

                } else {



                }
            },
            'sirkettipi': function (value) {
                if (value == '0') {
                    this.mevcutsirketmi = true;
                    this.yenisirket = false;
                    this.dialogyenisirket = false;

                } else {
                    this.dialogyenisirket = true;
                    this.mevcutsirketmi = false;
                    this.yenisirket = true;

                }
            }



        }

    }

    function beforeMount() {

        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));

        var sirketlers = []
        Object.keys(response1.MusteriDbler).forEach(key => {
            var sirket = {
                text: response1.MusteriDbler[key].Ad,
                id: response1.MusteriDbler[key].MusteriKod,
                baglisirketler: response1.MusteriDbler[key].GenelSirketler
            }
            sirketlers.push(sirket)
        });

        this.AnaSirketler = sirketlers;
        this.AnaSirketlerWiev = [];

        this.AnaSirket = null

        var params = {
            ProductID: 0,
            ProductType: 0
        }

        this.$http.post(auth.API_URL + 'api/Register/ProductList', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.urunlerlist = response.body
            this.productshow = [];
            this.urunlerlist.forEach(element => {
                if (element.UrunTip == 2)
                    this.productshow.push(element)
            });
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-ProductList'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-ProductList'
                this.snackbar = true
            }
        })

    }

    function guncelle() {

        //ana şirketleri alıyoruz

        var response1 = JSON.parse(window.localStorage.getItem('response'));


        //ManageLoad bilgilerin alıyorum kullanıcının hangi ana şirkette hangi yetkisi bulunuyor.

        var userparams = {
            Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
            this.pass = response.body.UserInfo.Sifre

            var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));


            var sirketlers = []

            Object.keys(response1.MusteriDbler).forEach(key => {
                var sirket = {
                    text: response1.MusteriDbler[key].Ad,
                    id: response1.MusteriDbler[key].MusteriKod,
                    baglisirketler: response1.MusteriDbler[key].GenelSirketler
                }
                sirketlers.push(sirket)
            });

            this.AnaSirketler = sirketlers;
            this.AnaSirketlerWiev = [];
            var yedeklist = []


            this.AnaSirketler.forEach(element => {
                var aktifmi = response2.AnaSirketInfo.map(function (e) {
                    return e.MusteriKod;
                }).indexOf(element.id);
                var id = element.id;
                var text = element.text;
                var baglisirket = [];
                var active = response2.AnaSirketInfo[aktifmi].Aktif
                baglisirket = element.baglisirketler

                var params = {
                    MusteriInfo: {
                        MusteriKod: element.id
                    }
                }
                this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if (response.body.UyelikStatus != true) {
                        active = false
                    }

                    var sirket = {
                        id: id,
                        text: text,
                        UyelikBitis: response.body.UyelikBitis,
                        UyelikTip: response.body.UyelikTip,
                        KalanKontor: response.body.KalanKontor,
                        UyelikStatus: response.body.UyelikStatus,
                        baglisirketler: baglisirket,
                        active: active
                    }
                    yedeklist.push(sirket)
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    } else {

                        this.text1 = 'Service Unavailable-ProductCustomerInfo'
                        this.snackbar = true
                    }
                })
            });

            this.AnaSirketlerWiev = yedeklist


        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserManageLoad'
                this.snackbar = true
            }
        })
    }

    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }
</script>